import enviro from 'enviro';
const GENERIC_OAUTH_APP_IDS = {
  QA: 44349652,
  PROD: 50112219
};
export const GENERIC_OAUTH_APP_ID = enviro.isQa() ? GENERIC_OAUTH_APP_IDS.QA : GENERIC_OAUTH_APP_IDS.PROD;